var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow"},[_c('h3',[_c('a',{attrs:{"id":"_0"}}),_vm._v("权限指令")]),_c('p',[_vm._v("通过以下指令控制按钮 是否显示。")]),_c('pre',[_c('code',{staticClass:"lang-language"},[_vm._v(" v-if=\"hasPermission('xx:xx:xx')\"\r\n")])])])])
}]

export { render, staticRenderFns }